import { B_FLOW_ID, C_FLOW_ID, PL_FLOW_ID } from '../boilerplate/item-ids';

/**
 * Transformer that sets a css color variable depending on current flow.
 * Each flow has its own color.
 */
export default (kasko) => {
  const inputState = kasko.getState('input');

  const routeState = kasko.getState().route.state.url;
  if (routeState.includes('private-liability')) {
    document.documentElement.style.setProperty('--state-primary', '#FB8900');
  } else if (routeState.includes('buildings')) {
    document.documentElement.style.setProperty('--state-primary', '#F05D23');
  } else if (routeState.includes('common')) {
    document.documentElement.style.setProperty('--state-primary', '#000000');
  } else if (routeState === '/access-pin' || routeState === '/save-later-success') {
    if (inputState.item_id === C_FLOW_ID) {
      document.documentElement.style.setProperty('--state-primary', '#433894');
    } else if (inputState.item_id === PL_FLOW_ID) {
      document.documentElement.style.setProperty('--state-primary', '#FB8900');
    } else if (inputState.item_id === B_FLOW_ID) {
      document.documentElement.style.setProperty('--state-primary', '#F05D23');
    } else {
      document.documentElement.style.setProperty('--state-primary', '#000000');
    }
  } else {
    document.documentElement.style.setProperty('--state-primary', '#433894');
  }

  kasko.addEventListener('route-changed', (changes) => {
    const currentInputState = kasko.getState('input');

    const currentPath = changes.current?.path;
    if (currentPath.includes('private-liability')) {
      document.documentElement.style.setProperty('--state-primary', '#FB8900');
    } else if (currentPath.includes('buildings')) {
      document.documentElement.style.setProperty('--state-primary', '#F05D23');
    } else if (currentPath.includes('common')) {
      document.documentElement.style.setProperty('--state-primary', '#000000');
    } else if (currentPath === 'access-pin' || currentPath === 'save-later-success') {
      if (currentInputState.item_id === C_FLOW_ID) {
        document.documentElement.style.setProperty('--state-primary', '#433894');
      } else if (currentInputState.item_id === PL_FLOW_ID) {
        document.documentElement.style.setProperty('--state-primary', '#FB8900');
      } else if (currentInputState.item_id === B_FLOW_ID) {
        document.documentElement.style.setProperty('--state-primary', '#F05D23');
      } else {
        document.documentElement.style.setProperty('--state-primary', '#000000');
      }
    } else {
      document.documentElement.style.setProperty('--state-primary', '#433894');
    }
  });
};
